import React, { useState, useEffect } from "react";
import config from "config.json";
import moment from "moment";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

function Account({ isReadOnly = false, roleDetails = {}, setRoleDetails }) {
  const [refresh, setRefresh] = useState(false);
  const [birthdate, setBirthdate] = useState(null);

  useEffect(() => {
    if(roleDetails["date_of_birth"]){
      let dateofbirth = moment(
        roleDetails["date_of_birth"],
        "YYYY-MM-DD"
      );
      setBirthdate(dateofbirth.toDate());
    }
  }, [roleDetails]);

  function getValue() {
    return (roleDetails["position"] || []).map((el) => {
      return { label: el, value: el };
    });
  }

  return (
    <div className="App">
      <div className="block">
        <div className="field">
          <label className="label">Data de nascimento *</label>
          <p className="control">
            <DatePicker
              className="input"
              scrollableYearDropdown
              yearDropdownItemNumber={15}
              selected={birthdate}
              value={birthdate }
              disabled={isReadOnly}
              onChange={(value) => { 
                setBirthdate(value);
                roleDetails["date_of_birth"] = moment(value).format('YYYY-MM-DD')
                setRoleDetails(roleDetails); }}
              dateFormat="dd/MM/yyyy"
              showYearDropdown
              dropdownMode="select"
            />
          </p>
        </div>
      </div>
      <div className="field">
        <label className="label">Peso (kg)</label>
        <div className="control">
          <input
            className="input"
            type="text"
            disabled={isReadOnly}
            value={
              roleDetails && roleDetails["age"] ? roleDetails["age"] : null
            }
            onChange={(event) => {
              roleDetails["age"] = event.target.value;
              setRoleDetails(roleDetails);
            }}
            placeholder="70"
          />
        </div>
      </div>

      <div className="field">
        <label className="label">Altura (cm)</label>
        <div className="control">
          <input
            className="input"
            type="text"
            disabled={isReadOnly}
            value={
              roleDetails && roleDetails["height"]
                ? roleDetails["height"]
                : null
            }
            onChange={(event) => {
              roleDetails["height"] = event.target.value;
              setRoleDetails(roleDetails);
            }}
            placeholder="175"
          />
        </div>
      </div>

      <div className="field">
        <label className="label">Zerozero link</label>
        <div className="control">
          <input
            className="input"
            type="text"
            disabled={isReadOnly}
            value={
              roleDetails && roleDetails["zerozero_link"]
                ? roleDetails["zerozero_link"]
                : null
            }
            onChange={(event) => {
              roleDetails["zerozero_link"] = event.target.value;
              setRoleDetails(roleDetails);
            }}
            placeholder="https://www.zerozero.pt/player.php?id=1579"
          />
        </div>
      </div>

      <div className="field">
        <label className="label">Posição *</label>
        <Select
          isMulti
          isDisabled={!!isReadOnly}
          value={getValue()}
          isOptionDisabled={() =>
            roleDetails["position"] && roleDetails["position"].length >= 3
          }
          onChange={(evt) => {
            roleDetails["position"] = evt.map((el) => el.value);
            setRoleDetails(roleDetails);
            setRefresh(!refresh); // necessary to refresh after the setRoleDetails
          }}
          options={config.POSITIONS_PLAYER}
        />
      </div>
      <br></br>
    </div>
  );
}
export default Account;
